// LLM generated - Model Claude 4 Sonnet

import { Text } from '~/domains/design-system/Text';
import type { PublicBoostTerms } from '~/domains/contest/domains/services/interfaces/propsService/api/boosts';
import type { BonusTermsCombined } from '~/domains/promotions/types/bonus.types';

import type { VoucherTerms } from '../../types/voucher.types';

import { useStyles } from './PromoTermsModal.styles';

type PromoTermsContentProps = {
  terms?: PublicBoostTerms | VoucherTerms | BonusTermsCombined;
};

/**
 * Component for rendering promotion terms content
 * Handles both boost and voucher terms with unified rendering logic
 */
export function PromoTermsContent({ terms }: PromoTermsContentProps) {
  const { classes } = useStyles();

  const parseLinks = (text: string) =>
    text.replace(
      /{link:(.*?)\|(.*?)}/g,
      (_, p1, p2) => `<a href="${p1}" target="_blank" rel="noopener noreferrer">${p2}</a>`
    );

  if (!terms) return null;

  return (
    <>
      {terms.type_title && terms.type_description && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>{terms.type_title}</div>
          <div
            className={classes.sectionContent}
            dangerouslySetInnerHTML={{ __html: parseLinks(terms.type_description) }}
          />
        </div>
      )}

      {terms.tags && terms.tags.length > 0 && (
        <div className={classes.tags}>
          {terms.tags.map((tag) => (
            <div key={tag} className={classes.pill}>
              <Text variant="subhead-x-small" color="gray2.6">
                {tag}
              </Text>
            </div>
          ))}
        </div>
      )}

      {terms.eligibility && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Eligibility</div>
          <div className={classes.sectionContent}>
            {terms.eligibility.paragraphs?.map((p) => (
              <p key={p} dangerouslySetInnerHTML={{ __html: parseLinks(p) }} />
            ))}
            {terms.eligibility.ordered_list && (
              <ol className={classes.list}>
                {terms.eligibility.ordered_list.map((item) => (
                  <li key={item} dangerouslySetInnerHTML={{ __html: parseLinks(item) }} />
                ))}
              </ol>
            )}
          </div>
        </div>
      )}

      {terms.rules && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Rules</div>
          <div className={classes.sectionContent}>
            {terms.rules.paragraphs?.map((p) => (
              <p key={p} dangerouslySetInnerHTML={{ __html: parseLinks(p) }} />
            ))}
            {terms.rules.ordered_list && (
              <ol className={classes.list}>
                {terms.rules.ordered_list.map((item) => (
                  <li key={item} dangerouslySetInnerHTML={{ __html: parseLinks(item) }} />
                ))}
              </ol>
            )}
          </div>
        </div>
      )}
    </>
  );
}
